<template>
  <div :class="$options.name">
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        <!--        <v-btn-->
        <!--          v-permission="['metrics-create']"-->
        <!--          class="primary"-->
        <!--          @click="$dialog.show('metrics-dialog')"-->
        <!--        >-->
        <!--          Добавить-->
        <!--        </v-btn>-->
      </v-toolbar>
      <v-data-table
        :items="list"
        :headers="headers"
        :loading="isLoading"
        :items-per-page="20"
        hide-default-footer
      >
        <template #item.actions="{ item }">
          <div class="data-table-actions">
            <v-btn
              v-permission="['metrics-edit']"
              color="light"
              :class="{ w100: $vuetify.breakpoint.lgAndDown }"
              x-small
              @click="$dialog.show('metric-dialog', { item })"
            >
              <v-icon left>edit</v-icon> Редактировать
            </v-btn>
          </div>
        </template>

        <template #item.filterable="{ item }">
          {{ item.filterable ? 'Да' : 'Нет' }}
        </template>

        <template v-if="pagination" #footer>
          <v-pagination
            :length="pagination.lastPage"
            :total-visible="8"
            :value="pagination.currentPage"
            :disabled="pagination.lastPage === 1"
            color="blue darken-3"
            class="pb-4 pt-4"
            @input="onChangePage($event)"
          />
        </template>
      </v-data-table>
    </v-card>
    <metric-dialog />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MetricDialog from './components/MetricDialog.vue';

export default {
  name: 'references-metrics-list-view',
  asyncData({ store }) {
    return store.dispatch('metrics/getList');
  },
  components: { MetricDialog },
  data: () => ({
    isLoading: false,
    activeItem: null,
    itemIsLoading: false,
    itemIsDeleting: false,
    formValid: true,
    headers: [
      { value: 'name', text: 'Название', sortable: false },
      { value: 'formula', text: 'Метрика', sortable: false },
      { value: 'filterable', text: 'Учавствует в фильтрации', sortable: false },
      { value: 'criticalLevel', text: 'Критический уровень', sortable: false },
      {
        value: 'actions',
        sortable: false,
        width: '30%',
        align: 'right',
      },
    ],
    rules: {
      name: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
    },
  }),
  computed: {
    ...mapState('metrics', ['list', 'pagination']),
  },
  methods: {
    ...mapActions('metrics', ['create', 'update', 'remove', 'getNextPage', 'getList']),
    ...mapActions(['showNotify']),

    async onChangePage(page) {
      this.isLoading = true;
      await this.getNextPage({ page });
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.icons-upload {
  border-radius: 4px;
}
.icon-form {
  position: sticky;
  top: 88px;
}
</style>
